import { styled } from "@cirrus/ui-kit/src"

export const LabelsContainer = styled("div")({
  display: "flex",
  flexWrap: "wrap",
  gap: "4px",
  marginTop: "8px",
  fontWeight: "normal",
  
  "& .toggle-button": {
    color: "#0055b0",
    cursor: "pointer"
  }
})
